<div class="modal-gallery-page">
  <h1 class="text-2xl font-dm font-bold text-ld-neutral mb-6 px-4 pt-4">Modal Gallery</h1>
  <p class="text-sm text-ld-neutral-500 mb-8 px-4">
    Visual verification of all modal components with standardized button styling and text justification.
  </p>
  <nav class="gallery-nav">
    <a href="/screenshots" class="gallery-nav-link">Screenshot Gallery</a>
    <a href="/style-guide" class="gallery-nav-link">Style Guide</a>
  </nav>

  <div class="modal-grid">
    <div class="modal-cell">
      <h3 class="modal-label">asset-summary-modal</h3>
      <div class="modal-wrapper">
        <ld-asset-summary-modal [linkedAccounts]="mockAccounts" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">bank-selection-modal</h3>
      <div class="modal-wrapper">
        <ld-bank-selection-modal [popularInstitutions]="mockPopularInstitutions" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">borrower-identity-modal</h3>
      <div class="modal-wrapper">
        <ld-borrower-identity-modal [borrowers]="mockBorrowerIdentity" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">confirm-address-modal</h3>
      <div class="modal-wrapper">
        <ld-confirm-address-modal
          [isOpen]="true"
          [street]="'123 Main St'"
          [city]="'Foothill Ranch'"
          [state]="'CA'"
          [zipCode]="'92610'"
        />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">confirmation-modal</h3>
      <div class="modal-wrapper">
        <ld-confirmation-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">confirmation-modal (destructive)</h3>
      <div class="modal-wrapper">
        <ld-confirmation-modal [isDestructive]="true" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">congratulations-modal</h3>
      <div class="modal-wrapper">
        <ld-congratulations-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">credit-card-modal</h3>
      <div class="modal-wrapper">
        <ld-credit-card-modal
          [loanId]="'loan-123'"
          [borrowerId]="'b-1'"
          [amount]="1525.43"
          [lookupZipFn]="mockLookupZipFn"
          [submitPaymentFn]="mockSubmitPaymentFn"
        />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">delete-assets-modal</h3>
      <div class="modal-wrapper">
        <ld-delete-assets-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">delete-payment-modal</h3>
      <div class="modal-wrapper">
        <ld-delete-payment-modal
          [isOpen]="true"
          [paymentId]="'pmt-1'"
          [loanNumber]="'1234567890'"
          [paymentAmount]="1525.43"
          [paymentDate]="mockPaymentReviewData.paymentDate"
        />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">delete-user-profile-modal</h3>
      <div class="modal-wrapper">
        <ld-delete-user-profile-modal [isOpen]="true" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">econsent-disclosure-modal</h3>
      <div class="modal-wrapper">
        <ld-econsent-disclosure-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">payment-electronic-communications-disclosure</h3>
      <div class="modal-wrapper">
        <ld-payment-electronic-communications-disclosure />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">paperless-electronic-communications-disclosure</h3>
      <div class="modal-wrapper">
        <ld-paperless-electronic-communications-disclosure />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">error-modal</h3>
      <div class="modal-wrapper">
        <ld-error-modal [isOpen]="true" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">error-modal (warning)</h3>
      <div class="modal-wrapper">
        <ld-error-modal [isOpen]="true" [icon]="'warning'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">force-update-modal</h3>
      <div class="modal-wrapper">
        <ld-force-update-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">google-maps-modal</h3>
      <div class="modal-wrapper">
        <ld-google-maps-modal [address]="'123 Main St, Foothill Ranch, CA 92610'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">heloc-eligibility-popup</h3>
      <div class="modal-wrapper">
        <ld-heloc-eligibility-popup />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">insurance-provider-selection-modal</h3>
      <div class="modal-wrapper">
        <ld-insurance-provider-selection-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">insurance-transition-modal</h3>
      <div class="modal-wrapper">
        <ld-insurance-transition-modal
          [loanId]="'loan-123'"
          [borrowerId]="'borrower-1'"
          [vendor]="'geico'"
          [getStateLicenseVerbiageFn]="mockGetStateLicenseVerbiageFn"
          [getInsuranceRedirectUrlFn]="mockGetInsuranceRedirectUrlFn"
          [getMelloInsurancePortalUrlFn]="mockGetMelloInsurancePortalUrlFn"
        />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">link-loan-mfa-modal</h3>
      <div class="modal-wrapper">
        <ld-link-loan-mfa-modal [isOpen]="true" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">link-loan-modal</h3>
      <div class="modal-wrapper">
        <ld-link-loan-modal [userName]="'John'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">loan-officer-search-modal</h3>
      <div class="modal-wrapper">
        <ld-loan-officer-search-modal
          [searchByNameFn]="mockSearchByNameFn"
          [searchByZipCodeFn]="mockSearchByZipCodeFn"
          [getLoanOfficersByBranchFn]="mockGetLoanOfficersByBranchFn"
        />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">loan-selection-modal</h3>
      <div class="modal-wrapper">
        <ld-loan-selection-modal [loans]="mockLoans" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">maintenance-modal</h3>
      <div class="modal-wrapper">
        <ld-maintenance-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">message-success-modal</h3>
      <div class="modal-wrapper">
        <ld-message-success-modal [isOpen]="true" [message]="'Your message has been sent successfully.'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">new-servicing-loan-modal (new-servicing-number)</h3>
      <div class="modal-wrapper">
        <ld-new-servicing-loan-modal [isOpen]="true" [loanNumber]="'1234567890'" [faqLink]="'/dashboard'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">new-servicing-loan-modal (transfer-to-nj)</h3>
      <div class="modal-wrapper">
        <ld-new-servicing-loan-modal
          [isOpen]="true"
          [loanNumber]="'1234567890'"
          [variant]="'transfer-to-nj'"
          [faqLink]="'/dashboard'"
        />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">missing-information-modal</h3>
      <div class="modal-wrapper">
        <ld-missing-information-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">paperless-promo-modal</h3>
      <div class="modal-wrapper">
        <ld-paperless-promo-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">paperless-prompt-modal</h3>
      <div class="modal-wrapper">
        <ld-paperless-prompt-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">partner-disclosure-modal</h3>
      <div class="modal-wrapper">
        <ld-partner-disclosure-modal [partnerType]="'home-renovation'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">payment-review-modal</h3>
      <div class="modal-wrapper">
        <ld-payment-review-modal [paymentData]="mockPaymentReviewData" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">phone-authorization-modal</h3>
      <div class="modal-wrapper">
        <ld-phone-authorization-modal [isOpen]="true" [mode]="'authorize'" [phoneNumber]="'8005551234'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">piit-transfer-modal</h3>
      <div class="modal-wrapper">
        <ld-piit-transfer-modal [isOpen]="true" [newServicer]="'New Mortgage Corp'" [transferDate]="mockTransferDate" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">request-callback-modal</h3>
      <div class="modal-wrapper">
        <ld-request-callback-modal [agents]="mockAgents" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">review-contact-info-modal</h3>
      <div class="modal-wrapper">
        <ld-review-contact-info-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">select-accounts-modal</h3>
      <div class="modal-wrapper">
        <ld-select-accounts-modal [accounts]="mockAccounts" [bankName]="'Chase Bank'" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">servisbot-prompt-modal</h3>
      <div class="modal-wrapper">
        <ld-servisbot-prompt-modal [isOpen]="true" [isBusinessHours]="true" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">session-timeout-modal</h3>
      <div class="modal-wrapper">
        <ld-session-timeout-modal [isOpen]="true" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">switch-borrower-modal</h3>
      <div class="modal-wrapper">
        <ld-switch-borrower-modal [borrowers]="mockBorrowers" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">tcpa-additional-loan-modal</h3>
      <div class="modal-wrapper">
        <ld-tcpa-additional-loan-modal [isOpen]="true" [currentLoanNumber]="1" [totalLoans]="3" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">terms-and-conditions-modal</h3>
      <div class="modal-wrapper">
        <ld-terms-and-conditions-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">terms-of-use-modal</h3>
      <div class="modal-wrapper">
        <ld-terms-of-use-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">unconsent-modal</h3>
      <div class="modal-wrapper">
        <ld-unconsent-modal />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">unsaved-changes-modal</h3>
      <div class="modal-wrapper">
        <ld-unsaved-changes-modal [isOpen]="true" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">upload-document-modal</h3>
      <div class="modal-wrapper">
        <ld-upload-document-modal [todo]="mockTodoItem" />
      </div>
    </div>

    <div class="modal-cell">
      <h3 class="modal-label">verify-borrower-modal</h3>
      <div class="modal-wrapper">
        <ld-verify-borrower-modal />
      </div>
    </div>
  </div>
</div>
